import styled from "styled-components"

const Chart = styled.div`
    display: flex;
    justify-content: center;
    height: 100%;
    padding-top: 1%;
    background: #546878;
    border-radius: 10px 10px 0 0;
`

export default Chart
